
function DNDButton({card, elementStyle, changeSelection, language}) {

    return (
      <div
        id="componentContainer"
        data-tour="rpdesigner-step-3"
        style={elementStyle}
        onClick={changeSelection}
      >
        <button
          type="button"
          id={"redirectbutton_" + card.name}
          style={{
            maxWidth: "90%",
            marginBottom: "5px",
            fontWeight: "500",
            fontSize: "0.875rem",
            lineHeight: "1.75",
            letterSpacing: "0.02857em",
            minWidth: "64px",
            padding: "6px 16px",
            borderRadius: "4px",
            color: "#fff",
            backgroundColor: card.buttonColor,
            border: "0",
            cursor: "pointer",
            fontSize: card.fontSize + "px",
          }}
        >
          {card.value[0].languages[language]}
        </button>
        <div id="redirect" style={{ display: "none" }}>
          {card.value[1].languages[language]}
        </div>

        <input
          readOnly
          id="displayDefault"
          style={{ display: "none" }}
          value={card.displayDefault}
        />
        <input
          readOnly
          id="displaySuccess"
          style={{ display: "none" }}
          value={card.displaySuccess}
        />
        <input
          readOnly
          id="displayError"
          style={{ display: "none" }}
          value={card.displayError}
        />
      </div>
    );
}

export default DNDButton;